import { modals } from '@mantine/modals'

import { AppointmentsByPersonRecordDto } from 'src/api/generated'

import AppointmentResult from '../AppointmentResult/AppointmentResult.component'
import { ManageAppointmentModalContent } from './ManageAppointmentModal.component'

//TODO any fix this in the refactor of appointment tools
export const openSuccessModal = (
  values: AppointmentsByPersonRecordDto | any,
  onScheduleNew: () => void,
  onViewAppointment: () => void,
) => {
  modals.open({
    children: (
      <AppointmentResult
        benefitType={values.benefitType}
        onScheduleNew={onScheduleNew}
        onViewAppointment={onViewAppointment}
      />
    ),
    size: 'md',
    centered: true,
    withCloseButton: false,
    closeOnEscape: false,
  })
}

export const openManageAppointmentModal = (
  personId: string,
  initialData?: AppointmentsByPersonRecordDto,
) =>
  modals.open({
    children: (
      <ManageAppointmentModalContent
        initialData={initialData}
        personId={personId}
      />
    ),
    size: 'xl',
    centered: true,
  })
